import { Github, Linkedin, Mail, FileText } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="border-t border-primary/10 py-12 px-4" role="contentinfo">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="text-muted-foreground" suppressHydrationWarning>
              © {currentYear} {t("footer.copyright")}
            </p>
          </div>

          <div className="flex gap-4">
            <a
              href="/impressum"
              className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center hover:bg-primary/20 hover:text-primary transition-all duration-300 hover:scale-110"
              aria-label="Impressum"
              title="Impressum"
            >
              <span className="sr-only">Impressum</span>
              <FileText className="h-5 w-5" />
            </a>
            <a
              href="https://github.com/kevske"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center hover:bg-primary/20 hover:text-primary transition-all duration-300 hover:scale-110"
              aria-label="GitHub"
              title="GitHub"
            >
              <span className="sr-only">GitHub (opens in a new tab)</span>
              <Github className="h-5 w-5" />
            </a>
            <a
              href="https://www.linkedin.com/in/kevin-rassner/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center hover:bg-primary/20 hover:text-primary transition-all duration-300 hover:scale-110"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <span className="sr-only">LinkedIn (opens in a new tab)</span>
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="mailto:kevin.rassner@gmail.com"
              className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center hover:bg-primary/20 hover:text-primary transition-all duration-300 hover:scale-110"
              aria-label="Email"
              title="Email"
            >
              <span className="sr-only">Email</span>
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
